import AIAssistantBanner from './AIAssistantBanner';

export default AIAssistantBanner;
